import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/components/ThemeProvider";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/Home";
import JobsPage from "@/pages/Jobs";
import JobDetailPage from "@/pages/JobDetail";
import AdminLoginPage from "@/pages/AdminLogin";
import AdminDashboardPage from "@/pages/AdminDashboard";
import AboutUsPage from "@/pages/AboutUs";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/jobs" element={<JobsPage />} />
              <Route path="/about-us" element={<AboutUsPage />} />
              <Route path="/jobs/:id" element={<JobDetailPage />} />
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route path="/admin" element={<AdminDashboardPage />} />
            </Routes>
          </BrowserRouter>
          <Toaster richColors position="top-right" />
        </div>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
